'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useImageAssetsUrl } from '@marketplace-web/shared/assets'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  icon: string
  title: string
  body: string
}

const FactBlock = ({ icon, title, body }: Props) => {
  const assetUrl = useImageAssetsUrl()

  return (
    <section className="page-section__fact-block">
      <div className="page-section__content">
        <div className="page-section__fact-icon">
          <Image src={assetUrl(`images/safety/${icon}.svg`)} size="large" alt="" />
        </div>
        <Spacer size="large" />
        <Text as="h4">
          <div className="safety_fact-title-small">{title}</div>
        </Text>
        <ResponsiveWrapper desktop={<Spacer />} />
        <Text as="span" html>
          <div className="safety_body">{body}</div>
        </Text>
      </div>
    </section>
  )
}

export default FactBlock
